import { render, staticRenderFns } from "./OrdineDettaglio.vue?vue&type=template&id=88588abc&scoped=true"
import script from "./OrdineDettaglio.vue?vue&type=script&lang=ts"
export * from "./OrdineDettaglio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88588abc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88588abc')) {
      api.createRecord('88588abc', component.options)
    } else {
      api.reload('88588abc', component.options)
    }
    module.hot.accept("./OrdineDettaglio.vue?vue&type=template&id=88588abc&scoped=true", function () {
      api.rerender('88588abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrdineDettaglio.vue"
export default component.exports